export default __webpack_public_path__ + "static/media/cards_deal4.a266cc98.mp3";